'use client';
import HolyLoader from 'holy-loader';

export default function TopLoader() {
  return <HolyLoader color='#FF9606' height='.3em' speed={250} easing='linear' />;
}
